import { GDQCategoryType } from '../types';

export interface PreloadedVerseOption {
  book: string;
  chapter: number;
  verse: number;
  verseText: string;
  prayer: string;
}

export const PRELOADED_VERSES: Record<GDQCategoryType, PreloadedVerseOption[]> = {
  'Wedding': [
    {
      book: 'Genesis',
      chapter: 2,
      verse: 24,
      verseText: 'For this reason a man will leave his father and mother and be united to his wife, and they will become one flesh.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, bless this new union. May their choice to leave and cleave bring a lifetime of unbroken oneness."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 4,
      verse: 9,
      verseText: 'Two are better than one, because they have a good return for their labor.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, multiply their efforts and grant them great success as an inseparable team in life."'
    },
    {
      book: '1 Corinthians',
      chapter: 13,
      verse: 4,
      verseText: 'Love is patient, love is kind. It does not envy, it does not boast, it is not proud.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, pour Your selfless love into their hearts. May patience and kindness always anchor their home."'
    },
    {
      book: 'Colossians',
      chapter: 3,
      verse: 14,
      verseText: 'And over all these virtues put on love, which binds them all together in perfect unity.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Heavy Father, bind this couple together. May Your sacrificial love be the ultimate fabric of their marriage."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 4,
      verse: 12,
      verseText: 'Though one may be overpowered, two can defend themselves. A cord of three strands is not quickly broken.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord Jesus, be the third strand in this marriage. Keep them strong and fully united in Your grace."'
    },
    {
      book: 'Ephesians',
      chapter: 4,
      verse: 2,
      verseText: 'Be completely humble and gentle; be patient, bearing with one another in love.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Grant them the grace to be gentle, patient, and quick to forgive as they walk out their vows."'
    },
    {
      book: '1 Corinthians',
      chapter: 13,
      verse: 7,
      verseText: 'It always protects, always trusts, always hopes, always perseveres.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, protect their commitment. May their love fiercely trust, constantly hope, and effortlessly endure through every season."'
    },
    {
      book: 'Song of Solomon',
      chapter: 8,
      verse: 7,
      verseText: 'Many waters cannot quench love; rivers cannot wash it away.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, give them an unquenchable love. May their bond withstand every trial and grow stronger through the years."'
    },
    {
      book: 'Romans',
      chapter: 12,
      verse: 10,
      verseText: 'Be devoted to one another in brotherly love. Outdo one another in showing honor.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Holy Spirit, cultivate deep devotion between them. May they find pure joy in putting each other first always."'
    },
    {
      book: 'Proverbs',
      chapter: 18,
      verse: 22,
      verseText: 'He who finds a wife finds a good thing and obtains favor from the LORD.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You, Lord, for this beautiful union. May Your favor and goodness richly rest upon their household forever."'
    },
    {
      book: 'Ephesians',
      chapter: 5,
      verse: 31,
      verseText: 'For this reason a man will leave his father and mother and be united to his wife, and the two will become one flesh.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, seal this sacred mystery of oneness. May their combined lives reflect Your glorious faithfulness to the world."'
    },
    {
      book: '1 Peter',
      chapter: 4,
      verse: 8,
      verseText: 'Above all, love one another deeply, because love covers over a multitude of sins.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, help them love each other deeply. May exceptional grace and quick forgiveness always cover their home."'
    },
    {
      book: 'Ruth',
      chapter: 1,
      verse: 16,
      verseText: 'But Ruth replied, \'Do not urge me to leave you or to turn back from following you. For where you go I will go, and where you stay I will stay. Your people will be my people and your God my God.\'',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Bless their shared journey, Lord. May their loyalty remain fierce and their shared faith in You grow deeper daily."'
    },
    {
      book: 'Song of Solomon',
      chapter: 3,
      verse: 4,
      verseText: 'Scarcely had I passed them when I found the one my soul loves. I held him and would not let him go...',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You for guiding them to each other. Protect the beautiful love they have found for a lifetime."'
    },
    {
      book: 'Philippians',
      chapter: 1,
      verse: 7,
      verseText: 'It is right for me to feel this way about all of you, since I have you in my heart...',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, keep their hearts forever knit together. May they always cherish, support, and uplift one another in love."'
    },
    {
      book: 'Ephesians',
      chapter: 4,
      verse: 32,
      verseText: 'Be kind and compassionate to one another, forgiving each other, just as in Christ God forgave you.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, make their home a sanctuary of kindness, genuine compassion, and the sweet, healing power of daily forgiveness."'
    },
    {
      book: 'Romans',
      chapter: 15,
      verse: 5,
      verseText: 'May the God who gives endurance and encouragement give you the same attitude of mind toward each other that Christ Jesus had,',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, grant them identical minds and hearts focused on serving each other with Christlike endurance and joy."'
    },
    {
      book: '1 John',
      chapter: 4,
      verse: 12,
      verseText: 'No one has ever seen God; but if we love one another, God remains in us, and His love is perfected in us.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "May Your tangible presence abide in their home, showing Your perfect love through their devotion to each other."'
    },
    {
      book: 'Psalms',
      chapter: 143,
      verse: 8,
      verseText: 'Let the morning bring me word of your unfailing love, for I have put my trust in you. Show me the way I should go, for to you I entrust my soul.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Direct their steps daily, Lord. May Your unfailing love greet them every morning as they build their life together."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, bless, keep, and look upon this couple. Infuse their marriage with Your abundant grace and everlasting peace."'
    }
  ],
  'Birthday': [
    {
      book: 'Psalms',
      chapter: 118,
      verse: 24,
      verseText: 'This is the day that the LORD has made; let us rejoice and be glad in it.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, fill their new year with joy. Thank You for the gift of their life and Your continuous goodness."'
    },
    {
      book: 'Proverbs',
      chapter: 9,
      verse: 11,
      verseText: 'For through wisdom your days will be multiplied, and years will be added to your life.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, grant them divine wisdom. Multiply their days and add seasons of deep fulfillment to their life."'
    },
    {
      book: 'Psalms',
      chapter: 139,
      verse: 14,
      verseText: 'I praise You because I am fearfully and wonderfully made; Your works are wonderful, I know that full well.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, remind them how wonderfully they are made. May they walk confidently in Your unique purpose this year."'
    },
    {
      book: '3 John',
      chapter: 1,
      verse: 2,
      verseText: 'Beloved, I pray that in all respects you may prosper and be in good health, just as your soul prospers.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, grant them vibrant health and prosperity. May their soul grow closer to You with each passing day."'
    },
    {
      book: 'Psalms',
      chapter: 20,
      verse: 4,
      verseText: 'May He grant the desires of your heart and fulfill all your plans.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, look kindly upon their dreams. Fulfill their righteous desires and bless all their plans this coming year."'
    },
    {
      book: 'Jeremiah',
      chapter: 29,
      verse: 11,
      verseText: 'For I know the plans I have for you,” declares the LORD, “plans to prosper you and not to harm you, plans to give you hope and a future.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, unfold Your prosperous plans for them. Grant them a future filled with bright hope and security."'
    },
    {
      book: 'Psalms',
      chapter: 91,
      verse: 16,
      verseText: 'With long life I will satisfy him and show him My salvation.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, satisfy them with a long, beautiful life. Reveal Your saving power and grace to them daily."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, shine Your face upon them. Be incredibly gracious and grant them absolute peace throughout this age."'
    },
    {
      book: 'Psalms',
      chapter: 23,
      verse: 6,
      verseText: 'Surely goodness and mercy will follow me all the days of my life, and I will dwell in the house of the LORD forever.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "May Your goodness and mercy pursue them every single day of this new year, keeping them close to You."'
    },
    {
      book: 'Proverbs',
      chapter: 3,
      verse: 1,
      verseText: 'My son, do not forget my teaching, but keep my commandments in your heart, for they will add length of days, years of life, and peace to you.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, keep Your truth in their heart. Increase their years and multiply their dynamic peace and joy."'
    },
    {
      book: 'Zephaniah',
      chapter: 3,
      verse: 17,
      verseText: 'The LORD your God is among you, a warrior who saves. He will rejoice over you with gladness; He will quiet you with His love; He will delight in you with singing.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, rejoice over them today. Quiet their anxieties with Your love and delight in them this year."'
    },
    {
      book: 'Psalms',
      chapter: 16,
      verse: 11,
      verseText: 'You have made known to me the path of life; You will fill me with joy in Your presence, with eternal pleasures at Your right hand.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Show them the path of life, Lord. Fill this birthday milestone with the pure joy of Your presence."'
    },
    {
      book: 'Isaiah',
      chapter: 46,
      verse: 4,
      verseText: 'Even to your old age I will be the same, and I will bear you even when your hair is gray. I have made you and I will carry you; I will sustain you and I will deliver you.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You, Lord, for carrying them safely. Sustain, protect, and deliver them through every chapter of life."'
    },
    {
      book: 'Psalms',
      chapter: 90,
      verse: 12,
      verseText: 'So teach us to number our days, that we may present a heart of wisdom.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Teach them to value every moment, Father. Cultivate a wise and grateful heart within them this year."'
    },
    {
      book: 'James',
      chapter: 1,
      verse: 17,
      verseText: 'Every good and perfect gift is from above, coming down from the Father of the heavenly lights, who does not change like shifting shadows.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, thank You for the perfect gift of their life. Rain down Your heavenly blessings upon them."'
    },
    {
      book: 'Psalms',
      chapter: 37,
      verse: 4,
      verseText: 'Delight yourself in the LORD, and He will give you the desires of your heart.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "May they find their ultimate delight in You, Lord. Grant the deepest, unspoken longings of their soul."'
    },
    {
      book: '2 Corinthians',
      chapter: 9,
      verse: 8,
      verseText: 'And God is able to make all grace overflow to you, so that in all things, at all times, having all that you need, you will abound in every good work.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Make Your grace overflow to them, Father. Provide for every need so they can abound in good works."'
    },
    {
      book: 'Ephesians',
      chapter: 2,
      verse: 10,
      verseText: 'For we are God’s workmanship, created in Christ Jesus to do good works, which God prepared in advance as our way of life.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, bless Your beautiful workmanship. Lead them safely into the purposeful works You pre-arranged for their life."'
    },
    {
      book: 'Psalms',
      chapter: 65,
      verse: 11,
      verseText: 'You crown the year with Your bounty, and Your carts overflow with abundance.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Crown their new age with Your goodness, Lord. May their life overflow with Your rich, spiritual abundance."'
    },
    {
      book: 'Romans',
      chapter: 15,
      verse: 13,
      verseText: 'May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope by the power of the Holy Spirit.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "God of hope, fill them with boundless joy and peace as they trust You throughout this new year."'
    }
  ],
  'Graduation': [
    {
      book: 'Jeremiah',
      chapter: 29,
      verse: 11,
      verseText: 'For I know the plans I have for you,” declares the LORD, “plans to prosper you and not to harm you, plans to give you hope and a future.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, unfold Your prosperous plans for this graduate. Lead them into a future filled with hope and purpose."'
    },
    {
      book: 'Proverbs',
      chapter: 3,
      verse: 5,
      verseText: 'Trust in the LORD with all your heart and lean not on your own understanding; in all your ways acknowledge Him, and He will make your paths straight.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, help them trust You completely. Straighten their paths as they acknowledge You in this next chapter."'
    },
    {
      book: 'Joshua',
      chapter: 1,
      verse: 9,
      verseText: 'Have I not commanded you? Be strong and courageous. Do not be afraid or discouraged, for the LORD your God is with you wherever you go.”',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Grant them strength and great courage, Lord. Remind them that Your presence goes with them everywhere."'
    },
    {
      book: 'Philippians',
      chapter: 4,
      verse: 13,
      verseText: 'I can do all things through Christ who strengthens me.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Jesus, be their constant source of strength. Empower them to achieve everything You have called them to do."'
    },
    {
      book: 'Psalms',
      chapter: 119,
      verse: 105,
      verseText: 'Your word is a lamp to my feet and a light to my path.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, let Your Word guide their next steps and illuminate the career paths ahead of them."'
    },
    {
      book: 'Proverbs',
      chapter: 16,
      verse: 3,
      verseText: 'Commit your works to the LORD, and your plans will be achieved.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, as they commit their new endeavors to You, establish their plans and grant them true success."'
    },
    {
      book: 'Philippians',
      chapter: 1,
      verse: 6,
      verseText: 'being confident of this very thing, that He who began a good work in you will complete it until the day of Jesus Christ;',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You for finishing this academic season, Lord. Complete the magnificent work You started in their life."'
    },
    {
      book: 'Matthew',
      chapter: 5,
      verse: 16,
      verseText: 'In the same way, let your light shine before men, that they may see your good deeds and glorify your Father in heaven.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, let their light shine brightly in their profession, bringing ultimate glory to Your name."'
    },
    {
      book: 'Colossians',
      chapter: 3,
      verse: 23,
      verseText: 'Whatever you do, work at it with all your heart, as working for the Lord and not for men,',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Give them an excellent spirit, Father. May they work wholeheartedly as unto You in every new opportunity."'
    },
    {
      book: 'Proverbs',
      chapter: 4,
      verse: 18,
      verseText: 'The path of the righteous is like the brightest light, shining brighter and brighter until the full day.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, cause their path to shine brighter and brighter as they step into leadership and impact."'
    },
    {
      book: 'James',
      chapter: 1,
      verse: 5,
      verseText: 'Now if any of you lacks wisdom, he should ask God, who gives generously to all without finding fault, and it will be given to him.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Pour out Your generous wisdom upon them, Father, as they make critical decisions for their future."'
    },
    {
      book: 'Romans',
      chapter: 12,
      verse: 2,
      verseText: 'Do not be conformed to this world, but be transformed by the renewing of your mind. Then you will be able to test and approve what is the good, pleasing, and perfect will of God.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Renew their mind daily, Lord. Keep them distinct and aligned with Your perfect, pleasing will."'
    },
    {
      book: 'Psalms',
      chapter: 20,
      verse: 4,
      verseText: 'May He grant the desires of your heart and fulfill all your plans.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, look favorably upon their professional ambitions. Fulfill their righteous desires and bless their future career."'
    },
    {
      book: '1 Timothy',
      chapter: 4,
      verse: 12,
      verseText: 'Let no one despise your youth, but be an example to the believers in word, in conduct, in love, in faith, in purity.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Make them an influential example of integrity, faith, and excellence in their marketplace or higher calling."'
    },
    {
      book: 'Isaiah',
      chapter: 40,
      verse: 31,
      verseText: 'but those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Renew their energy, Lord. May they soar like eagles into this new season without ever growing weary."'
    },
    {
      book: 'Psalms',
      chapter: 32,
      verse: 8,
      verseText: 'I will instruct you and teach you in the way you should go; I will counsel you with My loving eye on you.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Instruct and guide them continually, Father. Keep Your loving, protective eye upon them as they transition forward."'
    },
    {
      book: '2 Timothy',
      chapter: 1,
      verse: 7,
      verseText: 'For God has not given us a spirit of timidity, but of power and love and self-discipline.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Banish all fear of the future, Lord. Fill them with power, love, and sound self-discipline."'
    },
    {
      book: 'Ephesians',
      chapter: 2,
      verse: 10,
      verseText: 'For we are God’s workmanship, created in Christ Jesus to do good works, which God prepared in advance as our way of life.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lead Your workmanship into the meaningful, impactful careers You prepared for them before time began."'
    },
    {
      book: 'Micah',
      chapter: 6,
      verse: 8,
      verseText: 'He has shown you, O man, what is good. And what does the LORD require of you but to act justly, to love mercy, and to walk humbly with your God?',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Help them act justly, love mercy, and walk in deep humility with You throughout their life."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, bless this graduate, protect their steps, be gracious to them, and grant them everlasting peace."'
    }
  ],
  'Celebration of Life': [
    {
      book: 'Psalms',
      chapter: 116,
      verse: 15,
      verseText: 'Precious in the sight of the LORD is the death of His saints.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, comfort our hearts as we celebrate a life that is incredibly precious in Your eternal sight."'
    },
    {
      book: 'Matthew',
      chapter: 5,
      verse: 4,
      verseText: 'Blessed are those who mourn, for they will be comforted.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, fulfill Your promise to those who grieve. Comfort this family with Your overwhelming, gentle peace."'
    },
    {
      book: 'John',
      chapter: 11,
      verse: 25,
      verseText: 'Jesus said to her, \'I am the resurrection and the life. He who believes in Me will live, even though he dies;\'',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You, Jesus, for the hope of the resurrection. Anchor our souls in Your eternal promise."'
    },
    {
      book: 'Revelation',
      chapter: 21,
      verse: 4,
      verseText: 'He will wipe away every tear from their eyes. There will be no more death or mourning or crying or pain, for the old order of things has passed away.”',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, wipe away our tears. Comfort us with the beautiful reality of Your pain-free, eternal kingdom."'
    },
    {
      book: 'Psalms',
      chapter: 23,
      verse: 4,
      verseText: 'Even though I walk through the valley of the shadow of death, I will fear no evil, for You are with me; Your rod and Your staff, they comfort me.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Be near us in this dark valley, Lord. May Your protective presence bring us profound comfort."'
    },
    {
      book: '2 Corinthians',
      chapter: 1,
      verse: 3,
      verseText: 'Blessed be the God and Father of our Lord Jesus Christ, the Father of compassion and the God of all comfort, who comforts us in all our troubles...',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father of compassion, pour out Your supernatural comfort upon everyone gathering to remember this beautiful life."'
    },
    {
      book: 'Psalms',
      chapter: 73,
      verse: 26,
      verseText: 'My flesh and my heart may fail, but God is the strength of my heart and my portion forever.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "When our hearts fail with grief, Lord, sustain us. Be our strength and our eternal portion."'
    },
    {
      book: 'John',
      chapter: 14,
      verse: 1,
      verseText: 'Do not let your hearts be troubled. Trust in God; trust also in Me. In My Father’s house are many rooms...',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Quiet our troubled hearts, Jesus. Give us rest in the assurance of the heavenly home prepared for us."'
    },
    {
      book: 'Psalms',
      chapter: 46,
      verse: 1,
      verseText: 'God is our refuge and strength, an ever-present help in times of trouble.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, be our immediate refuge today. Give us physical and spiritual strength in this time of loss."'
    },
    {
      book: 'Romans',
      chapter: 14,
      verse: 8,
      verseText: 'If we live, we live to the Lord; and if we die, we die to the Lord. So whether we live or die, we belong to the Lord.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You, Father, for the sacred reminder that we belong safely to You in both life and death."'
    },
    {
      book: 'Joshua',
      chapter: 1,
      verse: 9,
      verseText: 'Have I not commanded you? Be strong and courageous. Do not be afraid or discouraged, for the LORD your God is with you wherever you go.”',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Banish our discouragement, Lord. Grant us divine courage as we face the days ahead without our loved one."'
    },
    {
      book: 'Psalms',
      chapter: 147,
      verse: 3,
      verseText: 'He heals the brokenhearted and binds up their wounds.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Holy Spirit, tenderly bind up our open emotional wounds and bring deep healing to our broken hearts."'
    },
    {
      book: '1 Thessalonians',
      chapter: 4,
      verse: 13,
      verseText: 'Brothers, we do not want you to be uninformed about those who sleep in death, so that you will not grieve like the rest, who are without hope.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, though we grieve, fill us with the confident, joyful hope of a future heavenly reunion."'
    },
    {
      book: 'Psalms',
      chapter: 34,
      verse: 18,
      verseText: 'The LORD is close to the brokenhearted; He saves those who are crushed in spirit.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Draw remarkably close to us today, Lord. Lift up every family member whose spirit feels completely crushed."'
    },
    {
      book: 'Romans',
      chapter: 8,
      verse: 38,
      verseText: 'For I am convinced that neither death nor life... will be able to separate us from the love of God that is in Christ Jesus our Lord.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You, Lord, that death cannot separate us or our departed loved ones from Your eternal love."'
    },
    {
      book: 'Philippians',
      chapter: 4,
      verse: 7,
      verseText: 'And the peace of God, which surpasses all comprehension, will guard your hearts and your minds in Christ Jesus.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Let Your incomprehensible peace stand guard over our fragile minds and heavy hearts during this season."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 3,
      verse: 1,
      verseText: 'There is a time for everything, and a season for every activity under heaven: a time to be born and a time to die,',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, help us rest in Your perfect timing as we honor the complete earthly season of this life."'
    },
    {
      book: 'Psalms',
      chapter: 90,
      verse: 12,
      verseText: 'So teach us to number our days, that we may present a heart of wisdom.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Teach us to cherish every moment, Lord, and to live with an eternal, wise perspective."'
    },
    {
      book: '2 Timothy',
      chapter: 4,
      verse: 7,
      verseText: 'I have fought the good fight, I have finished the race, I have kept the faith.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Thank You for their inspiring legacy of faith. Help us finish our own races with equal endurance."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, bless, keep, and look upon this couple. Infuse their marriage with Your abundant grace and everlasting peace."'
    }
  ],
  'Church': [
    {
      book: 'John',
      chapter: 3,
      verse: 16,
      verseText: 'For God so loved the world that He gave His one and only Son, that everyone who believes in Him shall not perish but have eternal life.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you fully grasp God\'s incredible love today and receive His precious, free gift of eternal life."'
    },
    {
      book: 'Romans',
      chapter: 10,
      verse: 13,
      verseText: 'For, \'Everyone who calls on the name of the Lord will be saved.\'',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord grant you full salvation and peace as you call out to Him in true faith."'
    },
    {
      book: 'Ephesians',
      chapter: 2,
      verse: 8,
      verseText: 'For it is by grace you have been saved through faith, and this not from yourselves; it is the gift of God,',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God reveal His wonderful grace to you today as you accept salvation as His free gift."'
    },
    {
      book: 'Acts',
      chapter: 3,
      verse: 19,
      verseText: 'Repent, then, and turn back, so that your sins may be wiped away,',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God wipe away every sin and bring deep, refreshing spiritual renewal to your heart today."'
    },
    {
      book: 'Matthew',
      chapter: 11,
      verse: 28,
      verseText: 'Come to Me, all you who are weary and burdened, and I will give you rest.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May Jesus lift every heavy burden from your shoulders and grant your soul true, supernatural rest."'
    },
    {
      book: 'Romans',
      chapter: 5,
      verse: 8,
      verseText: 'But God proves His love for us in this: While we were still sinners, Christ died for us.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you experience the immense depth of Christ\'s love, knowing He died to rescue and redeem you."'
    },
    {
      book: 'Revelation',
      chapter: 3,
      verse: 20,
      verseText: 'Behold, I stand at the door and knock. If anyone hears My voice and opens the door, I will come in and dine with him, and he with Me.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "As Jesus knocks on your heart today, may you find the courage to open the door to Him."'
    },
    {
      book: '2 Corinthians',
      chapter: 5,
      verse: 17,
      verseText: 'Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come!',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God break your old chains today and transform you into a beautiful, brand-new creation in Christ."'
    },
    {
      book: 'John',
      chapter: 14,
      verse: 6,
      verseText: 'Jesus answered, \'I am the way and the truth and the life. No one comes to the Father except through Me.\'',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Holy Spirit guide your steps to Jesus, revealing Him as your true way to the Father."'
    },
    {
      book: 'Isaiah',
      chapter: 1,
      verse: 18,
      verseText: '\'Come now, let us reason together,\' says the LORD. \'Though your sins are like scarlet, they shall be as white as snow;\'',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord wash away every deep stain of sin and make your heart as white as snow."'
    },
    {
      book: 'Luke',
      chapter: 19,
      verse: 10,
      verseText: 'For the Son of Man came to seek and to save what was lost.”',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May Jesus actively find you today, bringing His saving power and guidance directly into your life."'
    },
    {
      book: 'Romans',
      chapter: 6,
      verse: 23,
      verseText: 'For the wages of sin is death, but the gift of God is eternal life in Christ Jesus our Lord.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you be entirely rescued from sin\'s penalty and gladly receive God\'s gift of everlasting life."'
    },
    {
      book: 'John',
      chapter: 8,
      verse: 12,
      verseText: 'Once again Jesus spoke to the people and said, \'I am the light of the world. Whoever follows Me will never walk in darkness, but will have the light of life.\'',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May Christ shine His bright light into your darkness, leading you into a life of purpose."'
    },
    {
      book: 'Romans',
      chapter: 10,
      verse: 9,
      verseText: 'that if you confess with your mouth, \'Jesus is Lord,\' and believe in your heart that God raised Him from the dead, you will be saved.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God inspire saving faith in your heart as you confidently confess Jesus Christ as your Lord."'
    },
    {
      book: '1 John',
      chapter: 1,
      verse: 9,
      verseText: 'If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you experience God\'s absolute forgiveness and be thoroughly cleansed from all unrighteousness as you trust Him."'
    },
    {
      book: 'Psalms',
      chapter: 34,
      verse: 8,
      verseText: 'Taste and see that the LORD is good; blessed is the man who takes refuge in Him.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you taste and see the Lord\'s goodness today, finding absolute safety and refuge in Him."'
    },
    {
      book: '1 Timothy',
      chapter: 2,
      verse: 3,
      verseText: 'This is good and pleasing in the sight of God our Savior, who wants all men to be saved and to come to a knowledge of the truth.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God bring you into the fullness of His salvation and a deep knowledge of His truth."'
    },
    {
      book: 'John',
      chapter: 10,
      verse: 10,
      verseText: 'The thief comes only to steal and kill and destroy. I have come that they may have life, and have it to the full.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May Jesus defeat every plan against you and fill your life with His abundant, overflowing joy."'
    },
    {
      book: 'Joshua',
      chapter: 24,
      verse: 15,
      verseText: 'But if it is disagreeable in your sight to serve the LORD, choose for yourselves today whom you will serve... But as for me and my household, we will serve the LORD.”',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you and your household have the resolve to choose the Lord and serve Him with gladness."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord bless you, protect your steps, extend His marvelous grace, and grant you everlasting peace."'
    }
  ],
  'School': [
    {
      book: 'James',
      chapter: 1,
      verse: 5,
      verseText: 'Now if any of you lacks wisdom, he should ask God, who gives generously to all without finding fault, and it will be given to him.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, pour Your generous wisdom out upon our students and teachers as we navigate this school year."'
    },
    {
      book: 'Proverbs',
      chapter: 2,
      verse: 6,
      verseText: 'For the LORD gives wisdom; from His mouth come knowledge and understanding.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, be the source of all our learning. Grant our school deep knowledge and spiritual understanding."'
    },
    {
      book: 'Proverbs',
      chapter: 3,
      verse: 21,
      verseText: 'My son, do not lose sight of them, maintain sound wisdom and discretion; they will be life for your soul and adornment for your neck.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, help our students maintain sound wisdom and discretion in every choice they make today."'
    },
    {
      book: 'Daniel',
      chapter: 1,
      verse: 17,
      verseText: 'To these four young men God gave knowledge and skill in every branch of literature and wisdom; and Daniel had understanding of all kinds of visions and dreams.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, grant our students exceptional skill, academic excellence, and divine insight in all their studies."'
    },
    {
      book: 'Psalms',
      chapter: 119,
      verse: 99,
      verseText: 'I have more insight than all my teachers, for Your testimonies are my meditation.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, as our students meditate on Your truth, grant them deep insight and academic success."'
    },
    {
      book: 'Proverbs',
      chapter: 4,
      verse: 7,
      verseText: 'Wisdom is supreme; so acquire wisdom. And whatever else you obtain, gain understanding.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, above all worldly achievements, help our school community prioritize the pursuit of godly wisdom."'
    },
    {
      book: 'Philippians',
      chapter: 4,
      verse: 6,
      verseText: 'Do not be anxious about anything, but in everything, by prayer and petition, with thanksgiving, present your requests to God. And the peace of God, which surpasses all comprehension, will guard your hearts and your minds in Christ Jesus.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Calm all exam anxieties, Lord. Guard our students\' minds with Your incomprehensible composure and peace."'
    },
    {
      book: 'Colossians',
      chapter: 1,
      verse: 9,
      verseText: 'For this reason, since the day we heard about you, we have not stopped praying for you and asking God to fill you with the knowledge of His will through all spiritual wisdom and understanding,',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Fill our classrooms with the knowledge of Your will through all spiritual wisdom and understanding."'
    },
    {
      book: 'Proverbs',
      chapter: 14,
      verse: 15,
      verseText: 'The simpleton believes every word, but the prudent man watches his steps.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, guard our youth against deception. Grant them the discretion to watch their steps carefully."'
    },
    {
      book: 'James',
      chapter: 3,
      verse: 17,
      verseText: 'But the wisdom from above is first of all pure, then peace-loving, gentle, compliant, full of mercy and good fruits, unwavering, without hypocrisy.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, cultivate Your pure, peace-loving, and gentle wisdom within our students and staff alike."'
    },
    {
      book: 'Proverbs',
      chapter: 19,
      verse: 11,
      verseText: 'A man’s discretion makes him slow to anger, and it is to his glory to overlook an offense.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Grant our students composure and discretion, making them slow to anger and quick to show grace."'
    },
    {
      book: 'Isaiah',
      chapter: 26,
      verse: 3,
      verseText: 'You will keep in perfect peace him whose mind is steadfast, because he trusts in You.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Keep our school community in perfect peace. Let our minds remain completely steadfast and focused on You."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 7,
      verse: 12,
      verseText: 'For wisdom is a shelter, as money is a shelter, but the advantage of knowledge is this: Wisdom preserves the life of its owner.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, let Your wisdom be a protective shelter over our students, preserving their lives and character."'
    },
    {
      book: 'Colossians',
      chapter: 4,
      verse: 5,
      verseText: 'Act wisely toward outsiders, making the most of every opportunity.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Help us act wisely everyday, representing You well and making the most of every educational opportunity."'
    },
    {
      book: 'Proverbs',
      chapter: 1,
      verse: 4,
      verseText: 'to give prudence to the simple, knowledge and discretion to the youth—',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Father, pour out divine prudence, sharp knowledge, and mature discretion upon the youth in our school."'
    },
    {
      book: 'Ephesians',
      chapter: 1,
      verse: 17,
      verseText: 'I keep asking that the God of our Lord Jesus Christ, the glorious Father, may give you the Spirit of wisdom and revelation, so that you may know Him better.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Glorious Father, grant our school a Spirit of wisdom and revelation to know You intimately."'
    },
    {
      book: 'Proverbs',
      chapter: 16,
      verse: 21,
      verseText: 'The wise in heart are called discerning, and pleasant words increase learning.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Make our students discerning in heart, and let pleasant, encouraging words fill our hallways to boost learning."'
    },
    {
      book: '2 Timothy',
      chapter: 1,
      verse: 7,
      verseText: 'For God has not given us a spirit of timidity, but of power and love and self-discipline.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Banish fear from our classrooms, Lord. Endow us with power, love, and academic self-discipline."'
    },
    {
      book: 'Proverbs',
      chapter: 24,
      verse: 3,
      verseText: 'By wisdom a house is built, and through understanding it is established; through knowledge its rooms are filled with rare and beautiful treasures.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Build our institution on Your wisdom, Lord. Fill our minds with the beautiful treasures of Your truth."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; please say a prayer for us: "Lord, bless our school, keep us safe, shine Your grace upon us, and grant us perfect composure."'
    }
  ],
  'Work': [
    {
      book: 'Colossians',
      chapter: 3,
      verse: 23,
      verseText: 'Whatever you do, work at it with all your heart, as working for the Lord and not for men, since you know that you will receive an inheritance from the Lord as a reward. It is the Lord Christ you are serving.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you work wholeheartedly today, knowing your daily labor is a sacred service directly unto the Lord."'
    },
    {
      book: 'Genesis',
      chapter: 2,
      verse: 15,
      verseText: 'The LORD God took the man and put him in the Garden of Eden to cultivate it and keep it.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you find true dignity in your profession, and may God bless your efforts to cultivate your workspace."'
    },
    {
      book: 'Proverbs',
      chapter: 14,
      verse: 23,
      verseText: 'All hard work brings a profit, but mere talk leads only to poverty.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord grant you deep focus today and bless your industriousness with fruitfulness and profitability."'
    },
    {
      book: 'Psalms',
      chapter: 90,
      verse: 17,
      verseText: 'May the favor of the Lord our God rest upon us; establish for us the work of our hands—yes, establish the work of our hands.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the favor of God rest upon your career, establishing and bringing lasting success to your hands."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 3,
      verse: 13,
      verseText: 'And also that every man should eat and drink and find enjoyment in all his labor—this is the gift of God.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you receive the gift of deep satisfaction, finding true enjoyment in all your daily tasks."'
    },
    {
      book: 'Proverbs',
      chapter: 22,
      verse: 29,
      verseText: 'Do you see a man skilled in his work? He will stand before kings; he will not stand before obscure men.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God hone your unique skills and talents, opening doors of great influence and opportunity for you."'
    },
    {
      book: '1 Corinthians',
      chapter: 15,
      verse: 58,
      verseText: 'Therefore, my beloved brothers, be steadfast, immovable, always excelling in the work of the Lord, because you know that your labor in the Lord is not in vain.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you remain steadfast and motivated, knowing that no honest labor you do is ever in vain."'
    },
    {
      book: 'Galatians',
      chapter: 6,
      verse: 9,
      verseText: 'Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord renew your strength during times of professional fatigue, leading you to a joyful harvest."'
    },
    {
      book: 'Ephesians',
      chapter: 4,
      verse: 28,
      verseText: 'He who has been stealing must steal no longer, but must work, doing something useful with his own hands, that he may have something to share with those in need.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God bless your honest earnings, allowing you to live securely and support those in need generously."'
    },
    {
      book: 'Proverbs',
      chapter: 16,
      verse: 3,
      verseText: 'Commit your works to the LORD, and your plans will be achieved.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "As you commit your projects to the Lord, may He establish your plans and grant you victory."'
    },
    {
      book: '1 Thessalonians',
      chapter: 4,
      verse: 11,
      verseText: 'and to make it your ambition to lead a quiet life, to mind your own business, and to work with your hands, just as we commanded you, so that you may behave properly toward outsiders and be dependent on no one.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you walk in quiet excellence, making you highly respected, professional, and entirely independent in life."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 5,
      verse: 19,
      verseText: 'Furthermore, as for every man to whom God has given riches and wealth, He has also given him the ability to enjoy them, to accept his lot, and to rejoice in his labor. This is the gift of God.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord grant you a grateful heart to rejoice in your role and enjoy your fruits."'
    },
    {
      book: 'Proverbs',
      chapter: 12,
      verse: 11,
      verseText: 'He who tills his land will have plenty of bread, but he who pursues worthless antics lacks sense.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you stay focused on meaningful, productive work today, and may God bless your diligence with abundance."'
    },
    {
      book: '2 Thessalonians',
      chapter: 3,
      verse: 13,
      verseText: 'But as for you, brothers, do not grow weary in doing good.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "When professional challenges arise, may Father God give you the stamina to keep doing what is right."'
    },
    {
      book: 'Matthew',
      chapter: 5,
      verse: 16,
      verseText: 'In the same way, let your light shine before men, that they may see your good deeds and glorify your Father in heaven.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May your excellent workplace ethics and kindness reflect Christ\'s light brightly to all your corporate colleagues."'
    },
    {
      book: 'Proverbs',
      chapter: 10,
      verse: 4,
      verseText: 'Idle hands make a man poor, but diligent hands bring wealth.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord deliver you from procrastination and strengthen your hands to be diligent and highly resourceful."'
    },
    {
      book: 'Romans',
      chapter: 12,
      verse: 11,
      verseText: 'Do not lack diligence; be fervent in spirit; serve the Lord.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May God infuse you with professional drive and an enthusiastic spirit, making your work an act of worship."'
    },
    {
      book: 'Ecclesiastes',
      chapter: 9,
      verse: 10,
      verseText: 'Whatever your hand finds to do, do it with all your might,',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you receive absolute focus and physical energy to execute your current duties with maximum excellence."'
    },
    {
      book: 'Philippians',
      chapter: 2,
      verse: 14,
      verseText: 'Do everything without complaining or arguing, so that you may be blameless and pure, children of God without fault in a crooked and perverse generation, in which you shine as lights in the world',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May you collaborate peacefully with others today, shining brightly in your industry as a beacon of high integrity."'
    },
    {
      book: 'Numbers',
      chapter: 6,
      verse: 24,
      verseText: 'The LORD bless you and keep you; the LORD make His face shine upon you and be gracious to you; the LORD turn His face toward you and give you peace.',
      prayer: 'Thank you for playing our game; Here\'s a prayer for you: "May the Lord bless you, protect your career steps, extend His favor, and grant you workplace harmony."'
    }
  ],
  'Others': []
};
